import { type SVGProps } from 'react'
import { cn } from '#app/utils/misc.tsx'

type Props = SVGProps<SVGSVGElement> & {
	title?: string
}

function Logo({ className, title, ...props }: Props) {
	return (
		<svg
			viewBox="0 0 100 100"
			fill="none"
			aria-hidden={title ? undefined : true}
			role={title ? 'img' : undefined}
			className={cn('text-foreground h-8 w-8', className)}
			{...props}
		>
			{title ? <title>{title}</title> : null}
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M50 100C77.614 100 100 77.614 100 50 100 22.386 77.614 0 50 0 22.386 0 0 22.386 0 50 0 77.614 22.386 100 50 100Zm-14-67a3 3 0 0 0-3 3v28a3 3 0 0 0 3 3h28a3 3 0 0 0 3-3V36a3 3 0 0 0-3-3H36Z"
			/>
		</svg>
	)
}

export { Logo }
